/** TR02 copy (one group per control; a ticket edits only its own file). */
export const tr02PtBr = {
  title: 'Movimentos bancários conciliados e lançados',
  description:
    'Movimentos capturados no período: conciliação, alocação e efeito no razão, sem que um estado substitua outro.',
  reasons: {
    MOVEMENT_UNRECONCILED: 'Movimentos não conciliados',
    MOVEMENT_PARTIALLY_RECONCILED: 'Movimentos conciliados em parte (valor sem alocação)',
    RECONCILED_POSTING_FAILED: 'Conciliados com lançamento recusado',
    RECONCILED_POSTING_SKIPPED:
      'Conciliados com lançamento ignorado sem motivo que comprove cobertura',
    RECONCILED_NOT_POSTED: 'Conciliados sem lançamento efetivo no razão',
  },
  observations: {
    TR02_PERIOD_MOVEMENTS: 'Movimentos no período: {{count}}',
    TR02_IMPORTED_HISTORY: 'No histórico importado (razão adotado): {{count}}',
    TR02_POSTING_PATH_UNSUPPORTED:
      'Conciliados por um caminho sem evidência de lançamento suportada: {{count}}',
    TR02_RESTRICTED_ACCOUNT_FINDINGS: 'Pendências em contas com acesso restrito: {{count}}',
  },
};

export const tr02En: typeof tr02PtBr = {
  title: 'Bank movements reconciled and posted',
  description:
    'Movements captured in the period: reconciliation, allocation and GL effect, with no state standing in for another.',
  reasons: {
    MOVEMENT_UNRECONCILED: 'Unreconciled movements',
    MOVEMENT_PARTIALLY_RECONCILED: 'Partly reconciled movements (unallocated amount)',
    RECONCILED_POSTING_FAILED: 'Reconciled with a refused posting',
    RECONCILED_POSTING_SKIPPED: 'Reconciled with a skipped posting and no reason proving coverage',
    RECONCILED_NOT_POSTED: 'Reconciled with no effective GL posting',
  },
  observations: {
    TR02_PERIOD_MOVEMENTS: 'Movements in the period: {{count}}',
    TR02_IMPORTED_HISTORY: 'Inside the imported history (adopted ledger): {{count}}',
    TR02_POSTING_PATH_UNSUPPORTED:
      'Reconciled on a path with no supported posting evidence: {{count}}',
    TR02_RESTRICTED_ACCOUNT_FINDINGS: 'Open items on restricted-access accounts: {{count}}',
  },
};
